import { Component, OnInit, Inject, Output, EventEmitter } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { LocalStorageService } from 'ngx-webstorage';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog'; ///=== for searching pop up
import { PopuppatientsearchComponent } from '../popuppatientsearch/popuppatientsearch.component';
import { ProtocolsearchComponent } from '../protocolsearch/protocolsearch.component';
import { ProtocolHDModel } from 'src/app/models/ProtocolHDModel';
import { ProtocolDetModel } from 'src/app/models/ProtocolDetModel';
import { ProtocolDetService } from 'src/app/services/ProtocolDetService';
import { ItemsModel } from 'src/app/models/ItemsModel';
import { ItemsService } from 'src/app/services/ItemsService';
import { PharmGroupModel } from 'src/app/models/PharmGroupModel';
import { UnitsModel } from 'src/app/models/UnitsModel';
import { UnitsService } from 'src/app/services/UnitsService';
import { PharmGroupService } from 'src/app/services/PharmGroupService';
import { DoctorsService } from 'src/app/services/DoctorsService';
import { DoctorsModel } from 'src/app/models/DoctorsModel';
import { formatDate } from '@angular/common';
import { PatientModel } from 'src/app/models/PatientsModel';
import { PreparationHDModel } from 'src/app/models/PreparationHDModel';
import { PreparationHDService } from 'src/app/services/PreparationHDService';
import { DataBankService } from 'src/app/services/DataBankService';
import { DatabankModel } from 'src/app/models/DataBankModel';
import Swal from 'sweetalert2';
import { ProtocolHDService } from 'src/app/services/ProtocolHDService';
import { PreparationDetModel, PreparationDetNurseModel } from 'src/app/models/PreparationDetModel';
import { PreparationDetService } from 'src/app/services/PreparationDetService';
import { Router } from '@angular/router';
import { CanserService } from 'src/app/services/CanserService';
import { CanserModel } from 'src/app/models/CanserModel';
import { ExaminationsearchComponent } from '../examinationsearch/examinationsearch.component';
import { ExaminationModel } from 'src/app/models/ExaminationModel';
import { PreparationsearchComponent } from '../preparationsearch/preparationsearch.component';

import { PreprationLineComponent } from '../prepration-line/prepration-line.component';
import { ReportVewierComponent } from '../report-vewier/report-vewier.component';
import { ReportdialogComponent } from '../reportdialog/reportdialog.component';
import { NurseAssessmentService } from 'src/app/services/NurseAssessmentService';
import { NurseAssessmentModel, NurseFollowUpModel } from 'src/app/models/NurseAssessmentModel';
import { CancerTreatmentModel } from 'src/app/models/CancerTreatmentModel';
import { CancerTreatmentService } from 'src/app/services/CancerTreatmentService';
import { CurrentMedicationComponent } from '../current-medication/current-medication.component';


@Component({
  selector: 'app-preparation-order-nurse',
  templateUrl: './preparation-order-nurse.component.html',
  styleUrls: ['./preparation-order-nurse.component.css']
})
export class PreparationOrderNurseComponent implements OnInit {

    prepmasterid = '' ;
    category = '' ;
    prepimportant = '' ;
    starttieme = '' ;
    endtime = '' ;
    notes = '' ;
    compcode = '' ;
    userid = '' ;
    modifieddate = '' ;

  ProtocolCode = '';
  ProtocolDate = formatDate(new Date(), 'yyyy-MM-dd', 'en');
  ProtocolExDate = formatDate(new Date(), 'yyyy-MM-dd', 'en');
  paAge = 0;
  documentCode = '';
  documentCodeCopy = '';
  prHdCode = '';
  prHdName = '';
  docDate = formatDate(new Date(), 'yyyy-MM-dd', 'en');
  excDate = formatDate(new Date(), 'yyyy-MM-dd', 'en');
  cBcDate = formatDate(new Date(), 'yyyy-MM-dd', 'en');
  hiddenhead = false;
  wk_fontsize = '2ch';
  docPhCode = '';
  prHdCycle = 0;
  prHdDays = 0;
  prHdNotes = '';
  diganosis = '';

  prHdAdj ='0';
  prHdBsa ='0';
  prHdBonet ='No';
  prHdModifPerc ='0';
  prHdWhay ='';

  prHdPulse = '0';
  prHdB_P = '0';
  prHdTemp = '0';
  prHdCBG = '0';
  prHdWeight = '0';
  prHdHeight = '0';
  prHdAge = 0;
  compCode = '1';
  paSycle = 0;

  prDetCategory = '1';
  prDetCategory2 = '2';
  prDetCategory3 = '';

  prepsisp = '00.00';
  prepsaved = '00.00';

  prepsisp1 = '00.00';
  prepsaved1 = '00.00';

  prepsisp2 = '00.00';
  prepsaved2 = '00.00';

  prDetCatName = '';

  prDetItCode = '';

  prDetUnitCode = '';
  prDetUnitCode1 ='';
  prDetUnitCode2 = '';

  prDetUnit1='';
  preSolution ='';
  preSolution_1='';
  preSolution2='';

  prDetItName = '';
  prDetUnit = '';

  prDetDose = "";
  prDetDose1 = "";
  prDetQty = 0;
  prDetRote = 0;

  prDetDuration = '';
  prDetDuration1 = '';
  prDetDuration2 = '';

  prepImportant ='';    ///step
  prepImportant1 ='';    ///step
  prepImportant2 ='';    ///step

  autouserial =0;
  autouserial1=0;
  autouserial2 =0;

  prepRout ='';
  prepRout1 ='';
  prepRout2 ='';

  prNotes = '';
  prDetStep = '';
  categoryName ='';

  itCode = '';
  itCode1 = '';
  itCode2 = '';

  itTName0 = '';
  itTName1 ='';
  itTName2 ='';

  prDetQty1 = 0;
  prDetQty2 = 0;

  docCode = '';
  docName = '';
  docCode1 = '';
  docName1 = '';

  cancerID = '';

  patientCode = '';
  patientFName = '';

  birthDate = formatDate(new Date(), 'yyyy-MM-dd', 'en');
  dateEntry1 = formatDate(new Date(), 'yyyy-MM-dd', 'en');
  diagnosisDate = formatDate(new Date(), 'yyyy-MM-dd', 'en');
  potime :any;
  gender = '';
  pstatus = '';
  pathology = '';
  telMobile = '';
  userID = '';
  modifaiedDate = formatDate(new Date(), 'yyyy-MM-dd', 'en');
  prepFU =''
  prepFU1 =''
  prepFU2 =''
  prHdAdjSA ='0';

  PreMedicationList: ProtocolDetModel[] = [];
  ChemoList: ProtocolDetModel[] = [];
  SupprtList: ProtocolDetModel[] = [];

  pharmGroupList: PharmGroupModel[] = [];

  itemsList: ItemsModel[] = [];
  itemsList1: ItemsModel[] = [];
  itemsList2: ItemsModel[] = [];
  unitsList: UnitsModel[] = [];
  unitsList1: UnitsModel[] = [];
  unitsList2: UnitsModel[] = [];

  doctorsList: DoctorsModel[] = [];
  doctorsLis1: DoctorsModel[] = [];
  prepList: PreparationDetNurseModel[] = [];
  cancertreatmentList :CancerTreatmentModel[]=[];
  prepListChemo: PreparationDetNurseModel[] = [];
  prepListSupp:  PreparationDetNurseModel[] = [];

  prevPOList : PreparationHDModel[]=[];
  nursingnotes = '';
  cancerlist : CanserModel[]=[];
  @Output() submitClicked = new EventEmitter<any>();
  disablepharnacy = false;
  ReportURL0 =  'CocReports/PreparationOrder_D';
  Par1 = this.documentCode;
  wk_date = '2000-01-01'
  wk_type = '';
  step = 0;
  nursetime =formatDate(new Date(), 'HH:mm', 'en');
  wk_timein = 'وقت البدأ';
  wk_timeout = 'وقت الإنتهاء';
  timeParts =formatDate(new Date(), 'HH:mm', 'en');

  constructor(
    private dialogref: MatDialog,
    public ProtocolHDSelectedData: ProtocolHDModel,
    public protocolDetService: ProtocolDetService,
    public protocolHDService: ProtocolHDService,
    public itemsService: ItemsService,
    public unitsService: UnitsService,
    public pharmgroupService: PharmGroupService,
    public PreMedicationSelectedData: PreparationDetModel,
    public doctorsService: DoctorsService,
    public patientsSelectedData: PatientModel,
    public storage: LocalStorageService,
    public preparationHD: PreparationHDModel,
    public preparationDet: PreparationDetModel,
    public preparationHDService: PreparationHDService,
    public nursefollowup : NurseFollowUpModel,
    public preparationDetService: PreparationDetService,
    public dataBankService: DataBankService,
    public CanserService :CanserService,
    public cancersModel:CanserModel,
    public dataBankModel: DatabankModel,
    public examinationSelectedData:ExaminationModel,
    public nurseassessmentService : NurseAssessmentService,
    public nursefollowupService : NurseAssessmentService,
    public prepHDSelecteData : PreparationHDModel,
    public cancertreatmentService :CancerTreatmentService,

    public route: Router
  ) {  }

  ngOnInit(): void {

    this.retriveNextHD();


    this.retriveDoctorsLookupTop();
    this.retriveDoctorsLookupTopPh();
    this.retriveCancersLookupTop();
    this.prDetCategory = '1';
    this.prDetCategory2 = '2';
    this.prDetCategory3 = '';
    this.prevPOList=[];
    this.cancertreatmentList=[];

    this.docDate = formatDate(new Date(), 'yyyy-MM-dd', 'en');
    if (this.storage.retrieve('stgDocumentNumber') != null && this.storage.retrieve('stgDocumentNumber') !='')
    {

      this.documentCode= this.storage.retrieve('stgDocumentNumber');
      this.docDate =  this.storage.retrieve('stgDocumentDate');

      this.retrivePreHD();

    }
    else
    {

      this.patientCode =     this.storage.retrieve('stgPatientCode');
      this.docCode =  this.storage.retrieve('stgDoctorCode');
      this.docDate =  this.storage.retrieve('stgDocumentDate');

      this.retrievePatient();
    }


    this.excDate = formatDate(new Date(), 'yyyy-MM-dd', 'en');
    this.cBcDate = formatDate(new Date(), 'yyyy-MM-dd', 'en');
    if(this.storage.retrieve('stgGroup') !='4' && this.storage.retrieve('stgGroup') !='8'){
      this.disablepharnacy = true;
    }
    else
    {
      this.disablepharnacy = false;
    }
  }
  //// ---------------- Get Next Serial ------------------------
  retriveNextHD() {
    this.preparationHDService.getSerialHD(this.storage.retrieve('stgcompCode'))
      .subscribe((data: PreparationHDModel) => {
        this.documentCode = data.docNumber;
      });
  }
  /////////--------------Retrive Chemotherapy TTT Requests ---------------
  RetriveCancerTreatment(){
    this.cancertreatmentList = [];
    this.cancertreatmentService.getCancerTreatmentPatientChemo(this.patientCode,'1').subscribe((data: CancerTreatmentModel[]) => {
     this.wk_date = '2000-01-01';
     this.wk_type = '';
     for (let i = 0; i < data.length; i++) {
         this.cancertreatmentList[i] = data[i];
         var notes =  this.cancertreatmentList[i].trnotes;
         this.cancertreatmentList[i].trdate =formatDate(data[i].trdate, 'yyyy-MM-dd', 'en');
         this.cancertreatmentList[i].trstartdate =formatDate(data[i].trstartdate, 'yyyy-MM-dd', 'en');
         this.cancertreatmentList[i].trenddate =formatDate(data[i].trenddate, 'yyyy-MM-dd', 'en');
         if(data[i].trdose == 0){this.cancertreatmentList[i].trdose = null};

         if (data[i].trtype =='1' ){
           this.cancertreatmentList[i].wk_kind = '►Regimen';
           this.cancertreatmentList[i].trtype ='Chemotherapy';
           this.cancertreatmentList[i].trkindid =data[i].trtype;
           this.cancertreatmentList[i].trkind =data[i].trkind;
           this.unitsService.getUnits(data[i].trunit,'1').subscribe((data1: UnitsModel) => {
            this.cancertreatmentList[i].trunit = data1.unName;
          });
           this.cancertreatmentList[i].trunit =data[i].trunit;
           this.cancertreatmentList[i].trcycleno = data[i].trcycleno  ;
           this.cancertreatmentList[i].trdayscycle = data[i].trdayscycle ;
           this.cancertreatmentList[i].trstartdate =data[i].trstartdate ;
           this.cancertreatmentList[i].trdose = data[i].trdose ;
           var wk_Date = data[i].trdate;
            if (this.cancertreatmentList[i].trdate === this.wk_date )
               {this.cancertreatmentList[i].trdate = '';
              this.cancertreatmentList[i].username =''}
            else
               {this.cancertreatmentList[i].trdate =formatDate(data[i].trdate, 'yyyy-MM-dd', 'en')};
           this.wk_type =  this.cancertreatmentList[i].trkindid;
           this.wk_date =  wk_Date;
           if(this.cancertreatmentList[i].trdate == ''){this.hiddenhead = true};
         } ;


       }
     })
    }
  //------------------------------------------------------------
  //------------------  Retrive Patient Name -------------------
  retrievePatient() {
    this.dataBankService.getPatient(this.patientCode, this.compCode).subscribe((data: DatabankModel) => {
        this.patientFName = data.patientFName;
        this.paAge = Number(data.ageYear);
        this.RetrivePreviousTransactions();
        this.RetriveNursingAssessment();
        this.RetriveCancerTreatment();
      });

  }
  RetrivePreviousTransactions(){
    this.prevPOList=[];
    this.preparationHDService.getPreviousPrepHDLookupTop(this.patientCode, this.compCode).subscribe((data: PreparationHDModel[]) => {
      for (let index = 0; index < data.length; index++) {
        this.prevPOList[index] = data[index];
        this.prevPOList[index].docDate = formatDate(data[index].docDate, 'yyyy-MM-dd', 'en');
      }

    });
  }
  SetTimeStartPre(pro :PreparationDetNurseModel){

    if(pro.strattime == 'وقت البدأ' || pro.strattime == ''){
      pro.strattime = formatDate(new Date(), 'HH:mm aa', 'en');
    }

    const str1 = formatDate(new Date(), 'yyyy-MM-dd', 'en') + 'T' +this.nursetime+':00.000Z';
    this.nursefollowup.prepmasterid= this.documentCode;
    this.nursefollowup.category= pro.category;
    this.nursefollowup.prepimportant= pro.prepimportant.toString();
    this.nursefollowup.starttieme= str1;
    this.nursefollowup.endtime= null;
    this.nursefollowup.notes= pro.nursecomments1;
    this.nursefollowup.compcode= this.storage.retrieve('stgCompCode');
    this.nursefollowup.userid=  this.storage.retrieve('stguserId');
    this.nursefollowup.modifieddate= formatDate(new Date(), 'yyyy-MM-dd', 'en')
    this.nursefollowupService.AddNurseFollowUp(this.nursefollowup).subscribe(
      (data) => {
        this.mesgSave();
      },
      (error) => {
        alert(error);
      }
    );
    //pro.enditime = formatDate(str1, 'hh:mm aa', 'en');
    this.retrivePreHD();
  }
  SetTimeEndPre(pro: PreparationDetNurseModel) {

    if (pro.enditime == 'وقت الإنتهاء' || pro.enditime == '') {
      pro.enditime = formatDate(new Date(), 'HH:mm', 'en');
    }
    // Convert time string to a Date object
      const parseTime = (timeStr: string): Date => {
      const now = new Date();
      const [hours, minutes] = timeStr.match(/\d+/g)!.map(Number);
      const isPM = timeStr.includes('AM');

      return new Date(now.getFullYear(), now.getMonth(), now.getDate(),
                      isPM && hours !== 12 ? hours + 12 : hours,
                      minutes);
    };

    // Convert time strings to Date objects
    const startTime = parseTime(pro.strattime);
    const endTime = parseTime(pro.enditime);

    // Format the DateTime strings correctly
    const str1 = formatDate(startTime, 'yyyy-MM-dd\'T\'HH:mm:ss.SSS\'Z\'', 'en');
    const str2 = formatDate(endTime, 'yyyy-MM-dd\'T\'HH:mm:ss.SSS\'Z\'', 'en');

    this.nursefollowup.prepmasterid = this.documentCode;
    this.nursefollowup.category = pro.category;
    this.nursefollowup.prepimportant = pro.prepimportant.toString();
    this.nursefollowup.starttieme = str1;
    this.nursefollowup.endtime = str2;
    this.nursefollowup.notes = pro.nursecomments1;
    this.nursefollowup.compcode = this.storage.retrieve('stgCompCode');
    this.nursefollowup.userid = this.storage.retrieve('stguserId');
    this.nursefollowup.modifieddate = formatDate(new Date(), 'yyyy-MM-dd', 'en');

    this.nursefollowupService.AddNurseFollowUp(this.nursefollowup).subscribe(
      (data) => {
        this.mesgSave();
      },
      (error) => {
        alert(error);
      }
    );
    pro.enditime = formatDate(endTime, 'hh:mm aa', 'en');
  }
  SaveNotes(pro:PreparationDetNurseModel){
    // Convert time string to a Date object
    const parseTime = (timeStr: string): Date => {
     const now = new Date();
     const [hours, minutes] = timeStr.match(/\d+/g)!.map(Number);
     const isPM = timeStr.includes('PM');

     return new Date(now.getFullYear(), now.getMonth(), now.getDate(),
                     isPM && hours !== 12 ? hours + 12 : hours,
                     minutes);
   };

   // Convert time strings to Date objects
   var endempty = 'Ok';
   const startTime = parseTime(pro.strattime);
   if(pro.enditime == 'وقت الإنتهاء'){endempty = 'Non';pro.enditime =formatDate(new Date(), 'yyyy-MM-dd', 'en')}else{endempty = 'Ok'}
   const endTime = parseTime(pro.enditime);

   // Format the DateTime strings correctly
   const str1 = formatDate(startTime, 'yyyy-MM-dd\'T\'HH:mm:ss.SSS\'Z\'', 'en');
   const str2 = formatDate(endTime, 'yyyy-MM-dd\'T\'HH:mm:ss.SSS\'Z\'', 'en');

   this.nursefollowup.prepmasterid = this.documentCode;
   this.nursefollowup.category = pro.category;
   this.nursefollowup.prepimportant = pro.prepimportant.toString();
   this.nursefollowup.starttieme = str1;
   if(endempty == 'Non'){this.nursefollowup.endtime = null}else{this.nursefollowup.endtime = str2};
   this.nursefollowup.notes = pro.nursecomments1 + pro.nursecomments;
   this.nursefollowup.compcode = this.storage.retrieve('stgCompCode');
   this.nursefollowup.userid = this.storage.retrieve('stguserId');
   this.nursefollowup.modifieddate = formatDate(new Date(), 'yyyy-MM-dd', 'en');

   this.nursefollowupService.AddNurseFollowUp(this.nursefollowup).subscribe(
     (data) => {
      pro.nursecomments = '';
      this.RetrivePreChemo();
       this.mesgSave();
     },
     (error) => {
       alert(error);
     }
   );


 }
 ////======================== Current Medication ===============
  OpenDialogCurrentMedication(){
    if(this.patientCode == '' || this.patientCode == null){
      return;
    }
    const dialogRef = this.dialogref.open(CurrentMedicationComponent,
      {
        data: {
          dataKey: this.PreMedicationSelectedData,
          wk_source : 'Current Medication',
          wk_patientcode : this.patientCode,
          wk_date : this.docDate,
          disablepharnacy :this.disablepharnacy
        },
        width: '70vw',
      });
    dialogRef.afterClosed().subscribe(result => {

    });

      const dialogSubmitSubscription = dialogRef.componentInstance.submitClicked.subscribe(result => {
        dialogSubmitSubscription.unsubscribe();
      });
  }
 SaveNotesChemo(cho:PreparationDetNurseModel){
  // Convert time string to a Date object
  const parseTime = (timeStr: string): Date => {
   const now = new Date();
   const [hours, minutes] = timeStr.match(/\d+/g)!.map(Number);
   const isPM = timeStr.includes('PM');

   return new Date(now.getFullYear(), now.getMonth(), now.getDate(),
                   isPM && hours !== 12 ? hours + 12 : hours,
                   minutes);
 };

 // Convert time strings to Date objects
 var endempty = 'Ok';
   const startTime = parseTime(cho.strattime);
   if(cho.enditime == 'وقت الإنتهاء'){endempty = 'Non';cho.enditime =formatDate(new Date(), 'yyyy-MM-dd', 'en')}else{endempty = 'Ok'}

 const endTime = parseTime(cho.enditime);

 // Format the DateTime strings correctly
 const str1 = formatDate(startTime, 'yyyy-MM-dd\'T\'HH:mm:ss.SSS\'Z\'', 'en');
 const str2 = formatDate(endTime, 'yyyy-MM-dd\'T\'HH:mm:ss.SSS\'Z\'', 'en');

 this.nursefollowup.prepmasterid = this.documentCode;
 this.nursefollowup.category = cho.category;
 this.nursefollowup.prepimportant = cho.prepimportant.toString();
 this.nursefollowup.starttieme = str1;
 if(endempty == 'Non'){this.nursefollowup.endtime = null}else{this.nursefollowup.endtime = str2};
 this.nursefollowup.notes = cho.nursecomments1 + cho.nursecomments ;
 this.nursefollowup.compcode = this.storage.retrieve('stgCompCode');
 this.nursefollowup.userid = this.storage.retrieve('stguserId');
 this.nursefollowup.modifieddate = formatDate(new Date(), 'yyyy-MM-dd', 'en');
 //console.log("Comments:",cho.nursecomments,"-",this.nursefollowup.notes)
 this.nursefollowupService.AddNurseFollowUp(this.nursefollowup).subscribe(
   (data) => {
    cho.nursecomments = '';
     this.mesgSave();
     this.RetriveChemo();
   },
   (error) => {
     alert(error);
   }
 );
}

  SetTimeStartChemo(cho :PreparationDetNurseModel){

    if(cho.strattime == 'وقت البدأ' || cho.strattime == ''){
      cho.strattime = formatDate(new Date(), 'HH:mm aa', 'en');
    }
    const str1 = formatDate(new Date(), 'yyyy-MM-dd', 'en') + 'T' +this.nursetime+':00.000Z';
    this.nursefollowup.prepmasterid= this.documentCode;
    this.nursefollowup.category= cho.category;
    this.nursefollowup.prepimportant= cho.prepimportant.toString();
    this.nursefollowup.starttieme= str1;
    this.nursefollowup.endtime= null;
    this.nursefollowup.notes= cho.nursecomments;
    this.nursefollowup.compcode= this.storage.retrieve('stgCompCode');
    this.nursefollowup.userid=  this.storage.retrieve('stguserId');
    this.nursefollowup.modifieddate= formatDate(new Date(), 'yyyy-MM-dd', 'en')
    this.nursefollowupService.AddNurseFollowUp(this.nursefollowup).subscribe(
      (data) => {
        this.mesgSave();
      },
      (error) => {
        alert(error);
      }
    );
    this.retrivePreHD();
  }
  SetTimeEndChemo(cho :PreparationDetNurseModel){
    if(cho.enditime == 'وقت الإنتهاء' || cho.enditime == ''){
      cho.enditime = formatDate(new Date(), 'HH:mm aa', 'en');
    }
    // Convert time string to a Date object
    const parseTime = (timeStr: string): Date => {
      const now = new Date();
      const [hours, minutes] = timeStr.match(/\d+/g)!.map(Number);
      const isPM = timeStr.includes('AM');

      return new Date(now.getFullYear(), now.getMonth(), now.getDate(),
                      isPM && hours !== 12 ? hours + 12 : hours,
                      minutes);
    };

    // Convert time strings to Date objects
    const startTime = parseTime(cho.strattime);
    const endTime = parseTime(cho.enditime);

    // Format the DateTime strings correctly
    const str1 = formatDate(startTime, 'yyyy-MM-dd\'T\'HH:mm:ss.SSS\'Z\'', 'en');
    const str2 = formatDate(endTime, 'yyyy-MM-dd\'T\'HH:mm:ss.SSS\'Z\'', 'en');

    this.nursefollowup.prepmasterid = this.documentCode;
    this.nursefollowup.category = cho.category;
    this.nursefollowup.prepimportant = cho.prepimportant.toString();
    this.nursefollowup.starttieme = str1;
    this.nursefollowup.endtime = str2;
    this.nursefollowup.notes = cho.nursecomments;
    this.nursefollowup.compcode = this.storage.retrieve('stgCompCode');
    this.nursefollowup.userid = this.storage.retrieve('stguserId');
    this.nursefollowup.modifieddate = formatDate(new Date(), 'yyyy-MM-dd', 'en');

    this.nursefollowupService.AddNurseFollowUp(this.nursefollowup).subscribe(
      (data) => {
        this.mesgSave();
      },
      (error) => {
        alert(error);
      }
    );
    cho.enditime = formatDate(endTime, 'hh:mm aa', 'en');
  }

  RetriveNursingAssessment(){
     this.nurseassessmentService.GetNurseAssessment(this.patientCode, this.docDate).subscribe({
          next: (data: NurseAssessmentModel) => {
            this.prHdWeight = data.weight;
            this.prHdHeight = data.height;
            this.prHdB_P = data.pressure;
            this.prHdPulse = data.pulse;
            this.prHdTemp = data.temp;
            this.nursingnotes = data.nursenote;

          },
          error: (error) => {
            // Handle any actual errors here, if needed.  For example:
            console.error("Error fetching nurse assessment:", error);
            // You might also want to display an error message to the user.
          },
          complete: () => {
            // This block executes after a successful completion (even if data is null/undefined).
              if (!this.prHdWeight) {  // Check if visitlocation is undefined or null.  Could also check for an empty string "" if that's a possibility.
                  this.prHdWeight = '0';
              }
          }
        });
  }
  //-------------------  Retrive Preparation Order Header ------
  retrivePreHD() {
    this.preparationHDService.getPrepHD(this.documentCode, this.storage.retrieve('stgcompCode')).subscribe((data: PreparationHDModel) => {
        if (data.paIntCode == '' || data.paIntCode == null){return};
        this.documentCode  = data.docNumber;
        this.docDate = formatDate(data.docDate, 'yyyy-MM-dd', 'en');
        this.excDate = formatDate(data.exDate, 'yyyy-MM-dd', 'en');
        this.docCode = data.docCode;
        this.docCode1 = data.docPhCode;
        this.patientCode = data.paIntCode;
        this.birthDate = formatDate(data.paBirthDate, 'yyyy-MM-dd', 'en');
        this.gender = data.paGender;
        this.paAge = data.prepAge;
        this.cancerID = data.cancerType;
        this.diganosis = data.diganosis;
        this.diagnosisDate = formatDate(data.diganosisDate, 'yyyy-MM-dd', 'en');
        this.pathology = data.pathology;
        this.pstatus = data.patientStatus;
        this.cBcDate = formatDate(data.cBCDate, 'yyyy-MM-dd', 'en');

        this.prHdCode = data.paProtocol;
        this.prHdCycle = data.paSycle;
        this.prHdDays = data.paDays;
        this.prHdPulse = data.paPuls;
        this.prHdB_P = data.paBP;
        this.prHdCBG = data.paCBG;
        this.prHdWeight = data.paWeight;
        this.prHdHeight = data.paHeight;
        this.prHdTemp = data.paTemp;

        this.prNotes = data.notes;

        this.prHdAdj = data.prHdAdj;
        this.prHdBsa = data.prHdBsa;
        this.prHdBonet= data.prHdBonet;
        this.prHdModifPerc = data.prHdModifPerc;
        this.prHdWhay = data.prHdWhay;

        this.compCode = data.compCode;
        this.userID = data.userID;
        this.modifaiedDate = data.modifiedDate;
        this.retrievePatient();
        this.RetrivePreChemo();
        this.RetriveChemo();
        this.RetriveSupportive();
      });
    }
    RetrivePreChemo(){
      this.preparationDetService.getPrepDetNurseCat(this.documentCode, '1', this.compCode).subscribe((data: PreparationDetNurseModel[]) => {
        for (let index = 0; index < data.length; index++) {
          this.prepList[index] = data[index];
          this.nurseassessmentService.getNurseFollowUp(this.documentCode, '1', data[index].prepimportant.toString()).subscribe((data1: NurseFollowUpModel) => {
          this.prepList[index].strattime =formatDate(data1.starttieme, 'hh:mm aa', 'en');
          this.prepList[index].enditime = formatDate(data1.endtime, 'hh:mm aa', 'en');
          this.prepList[index].nursecomments1 = data1.notes;
          if(data1.starttieme == '' || data1.starttieme == null){this.prepList[index].strattime  = 'وقت البدأ'};
          if(data1.endtime == '' || data1.endtime == null){this.prepList[index].enditime  = 'وقت الإنتهاء'};
        }
      )}


      });


  }
RetriveChemo(){
  this.prepListChemo = [];
  this.preparationDetService.getPrepDetNurseCat(this.documentCode, '2', this.compCode).subscribe((data : PreparationDetNurseModel[]) => {
   for (let i = 0; i < data.length; i++) {
     this.prepListChemo[i] = data[i];
     this.nurseassessmentService.getNurseFollowUp(this.documentCode, '2', data[i].prepimportant.toString()).subscribe((data1: NurseFollowUpModel) => {
       debugger;
       this.prepListChemo[i].strattime =formatDate(data1.starttieme, 'hh:mm aa', 'en');
       this.prepListChemo[i].enditime = formatDate(data1.endtime, 'hh:mm aa', 'en');
       this.prepListChemo[i].nursecomments1 = data1.notes;
       if(data1.starttieme == '' || data1.starttieme == null){this.prepListChemo[i].strattime  = 'وقت البدأ'};
       if(data1.endtime == '' || data1.endtime == null){this.prepListChemo[i].enditime  = 'وقت الإنتهاء'};
   })}
 })
}
RetriveSupportive(){
  this.preparationDetService.getPrepDetNurseCat(this.documentCode, '3', this.compCode).subscribe((data) => {
    for (let index = 0; index < data.length; index++) {
      this.prepListSupp[index] = data[index];
      this.prepListSupp[index].strattime = 'وقت البدأ';
      this.prepListSupp[index].enditime = 'وقت الإنتهاء';

    }
  })
}
DoctorObservation(){
  this.storage.store('stgPatientCode',this.patientCode);
  this.storage.store('stgPatientName',this.patientFName);
  this.storage.store('stgVisitDate',this.docDate);
}
  //-------------------------Patient Search ---------------------
  openDialog() {
    const dialogRef = this.dialogref.open(PopuppatientsearchComponent, {
      data: {
        dataKey: this.patientsSelectedData,
      },
    });
    dialogRef.afterClosed().subscribe((result) => {});
    const dialogSubmitSubscription =
      dialogRef.componentInstance.submitClicked.subscribe((result) => {
        this.patientCode = result.patientCode;
        this.patientFName = result.patientFName;

        this.birthDate = formatDate(result.birthDate, 'yyyy-MM-dd', 'en');
        this.dateEntry1 = formatDate(result.dateEntry, 'yyyy-MM-dd', 'en');

        this.diganosis = result.diagnosis;
        this.gender = result.gender;
        this.pstatus = result.status;
        this.pathology = result.pathology;
        this.telMobile = result.telMobile;
        this.cancerID = result.cancerID;
        this.paAge = Number(result.ageYear);
        this.compCode = result.compCode;
        this.RetrivePreviousTransactions();
        this.RetriveNursingAssessment();
        this.RetriveCancerTreatment();
        this.userID = result.userID;
        this.modifaiedDate = result.modifaiedDate;
        dialogSubmitSubscription.unsubscribe();

      });
  }

  //----------------- Preparation Order Search ------------------
  openDialogOrder() {
    const dialogRef = this.dialogref.open(PreparationsearchComponent, {
      data: {
        dataKey: this.prepHDSelecteData,
      },
    });
    dialogRef.afterClosed().subscribe((result) => {});
    const dialogSubmitSubscription =
      dialogRef.componentInstance.submitClicked.subscribe((result) => {
        this.documentCode = result.docNumber;
        this.retrivePreHD();
        dialogSubmitSubscription.unsubscribe();

      });
  }

  NewData() {
    this.docDate = formatDate(new Date(), 'yyyy-MM-dd', 'en');
    this.excDate = formatDate(new Date(), 'yyyy-MM-dd', 'en');
    this.cBcDate = formatDate(new Date(), 'yyyy-MM-dd', 'en');
    this.prHdCode= '';
    this.documentCode = '';
    this.patientCode = '';
    this.patientFName = '';
    this.cancerID = '';
    this.pathology = '';
    this.birthDate = formatDate(new Date(), 'yyyy-MM-dd', 'en');
    this.dateEntry1 = formatDate(new Date(), 'yyyy-MM-dd', 'en');
    this.pstatus = '';
    this.paAge = 0;
    this.gender = '';
    this.diganosis = '';
    this.prHdName = '';
    this.prHdCycle = 0;
    this.prHdDays = 0;
    this.prHdNotes = '';

    this.prHdAdj ='0';
    this.prHdBsa ='0';
    this.prHdBonet ='No';
    this.prHdModifPerc ='0';
    this.prHdWhay ='';


    this.prHdPulse = '0';
    this.prHdB_P = '0';
    this.prHdTemp = '0';
    this.prHdCBG = '0';
    this.prHdWeight = '0';
    this.prHdHeight = '0';
    this.prDetDuration='';
    this.prepRout ='';
    this.prepRout1 ='';
    this.prepRout2 ='';


    this.docCode = '';
    this.docCode1 = '';
    this.compCode = this.storage.retrieve('stgcompCode');
    this.userID = this.storage.retrieve('stguserId');
    this.modifaiedDate = formatDate(new Date(), 'yyyy-MM-dd', 'en');

    this.storage.store('stgPatientCode','');
    this.storage.store('stgDoctorCode','');
    this.storage.store('stgDocumentNumber',0);
    this.prevPOList=[];
    this.retriveNextHD();
    this.PreMedicationList = [];
    this.ChemoList = [];
    this.SupprtList = [];

    this.prepList = [];
    this.prepListChemo = [];
    this.prepListSupp = [];
    this.cancertreatmentList=[];

  }
  /////*************************** Protocols Grids ***************************************************************
  /////-----***--------- Select Line From Preparation Order-------***-----------------------------------------------------
  ///------------  Select Line from Pre-Chemo to edit exicting line  ------------------------------------------
  SelectPreMedication(pro: PreparationDetModel) {
    this.prDetCategory = pro.category;
    this.PreMedicationSelectedData.categoryName = pro.categoryName;
    this.itCode = pro.drgserial;
    this.PreMedicationSelectedData.drgName = pro.drgName;

    if (pro.category === '1'){
      this.autouserial = pro.prepautoserial;
      this.itCode = pro.drgserial;
      this.itTName0 = pro.drgName;
      this.prDetQty = pro.perpDaose;
      this.prDetUnitCode = pro.uOM;
      this.prDetDuration= pro.prepDuration;
      this.prDetDose= pro.prepFD.toString();
      this.prepFU= pro.prepFU.toString();
      this.prepsisp= pro.prepdisp.toString();
      this.prepsaved= pro.prepsaved.toString();

      this.prepImportant= pro.prepImportant;
      this.preSolution = pro.preSolution;
      this.prepRout = pro.prepRout;

    }
    const dialogRef = this.dialogref.open(PreprationLineComponent,
      {
        data: {
          dataKey: this.PreMedicationSelectedData,
          wk_autoserial : this.autouserial,
          wk_serial :this.documentCode,
          wk_category : pro.category,
          wk_protocol : this.prHdCode,
          wk_patientcode : this.patientCode,
          wk_itcode : this.itCode,
          wk_itname : pro.drgName,
          wk_dose : this.prDetQty,
          wk_unit :this.prDetUnitCode,
          wk_duration : this.prDetDuration,
          wk_finaldose :this.prDetDose,
          wk_prepFU : this.prepFU,
          wk_dispensed :this.prepsisp,
          wk_saved : this.prepsaved,
          wk_important :this.prepImportant,
          wk_soloution :this.preSolution,
          wk_rout : this.prepRout
        },
        width: '75vw',
      });
    dialogRef.afterClosed().subscribe(result => {
           this.prepList =[];
           this.prepListChemo =[];
           this.prepListSupp =[];
           this.retrivePreHD();
    });

      const dialogSubmitSubscription = dialogRef.componentInstance.submitClicked.subscribe(result => {
        dialogSubmitSubscription.unsubscribe();
      });
  }
  ///------------  Select Line from Chemotherapy to edit exicting line  ------------------------------------------
  SelectChemoLine(cho: PreparationDetModel) {
    const dialogRef = this.dialogref.open(PreprationLineComponent,
      {
        data: {
          dataKey: this.PreMedicationSelectedData,
          wk_autoserial : cho.prepautoserial,
          wk_serial :this.documentCode,
          wk_category : cho.category,
          wk_protocol : this.prHdCode,
          wk_patientcode : this.patientCode,
          wk_itcode : cho.drgserial,
          wk_itname : cho.drgName,
          wk_dose : cho.perpDaose,
          wk_unit :cho.uOM,
          wk_prepFU : cho.prepFU,
          wk_duration : cho.prepDuration,
          wk_finaldose :cho.prepFD,
          wk_dispensed :cho.prepdisp,
          wk_saved : cho.prepsaved,
          wk_important :cho.prepImportant,
          wk_soloution :cho.preSolution,
          wk_rout : cho.prepRout
        },
        width: '75vw',
      });
    dialogRef.afterClosed().subscribe(result => {
      this.prepList =[];
      this.prepListChemo =[];
      this.prepListSupp =[];
      this.retrivePreHD();
    });

      const dialogSubmitSubscription = dialogRef.componentInstance.submitClicked.subscribe(result => {
        dialogSubmitSubscription.unsubscribe();
      });
  }
  ///------------  Select Line from Supportive TTT. to edit exicting line  ------------------------------------------
  SelectSupLine(sup: PreparationDetModel) {
    if (sup.category === '3'){
      this.autouserial2 = sup.prepautoserial;
      this.itCode2 = sup.drgserial;
      this.itTName2 = sup.drgName;
      this.prDetQty2 = sup.perpDaose;
      this.prDetUnitCode2 = sup.uOM;
      this.prDetDuration2= sup.prepDuration;
      this.prepImportant2= sup.prepImportant;
      this.preSolution2 = sup.preSolution;
      this.prepRout2 = sup.prepRout;
        }
        const dialogRef = this.dialogref.open(PreprationLineComponent,
          {
            data: {
              dataKey: this.PreMedicationSelectedData,
              wk_autoserial : this.autouserial2,
              wk_serial :this.documentCode,
              wk_category : sup.category,
              wk_protocol : this.prHdCode,
              wk_patientcode : this.patientCode,
              wk_itcode : this.itCode2,
              wk_itname : sup.drgName,
              wk_dose : this.prDetQty2,
              wk_unit :this.prDetUnitCode2,
              wk_duration : this.prDetDuration2,
              wk_finaldose :'00.00',
              wk_dispensed :'00.00',
              wk_saved : '00.00',
              wk_important :this.prepImportant2,
              wk_soloution :this.preSolution2,
              wk_rout : this.prepRout2
            },
            width: '75vw',
          });
        dialogRef.afterClosed().subscribe(result => {
          this.prepList =[];
          this.prepListChemo =[];
          this.prepListSupp =[];
          this.retrivePreHD();
          this.retrivePreHD();
        });


          const dialogSubmitSubscription = dialogRef.componentInstance.submitClicked.subscribe(result => {
            dialogSubmitSubscription.unsubscribe();
          });
  }
  ///-----------------------***---- Add New  Line   -----****-----------------------------------
  ///------------------------  Add New Line in Pre-Chemo   ------------------------------------------
  AddNewLine1(){
    if(this.patientCode == '' || this.patientCode == null){
      return;
    }
    const dialogRef = this.dialogref.open(PreprationLineComponent,
      {
        data: {
          dataKey: this.PreMedicationSelectedData,
          wk_autoserial : 0,
          wk_serial :this.documentCode,
          wk_category : '1',
          wk_protocol : this.prHdCode,
          wk_patientcode : this.patientCode,
          wk_itcode : '',
          wk_itname : '',
          wk_dose : '0',
          wk_unit :'16',
          wk_duration : '',
          wk_finaldose :'00.00',
          wk_dispensed :'00.00',
          wk_saved :'00.00',
          wk_important :'',
          wk_soloution :'',
          wk_rout : ''
        },
        width: '75vw',
      });
    dialogRef.afterClosed().subscribe(result => {

      //this.prepListChemo =[];
      //this.prepList =[];
      //this.prepListSupp =[];
      this.retrivePreHD();
    });

      const dialogSubmitSubscription = dialogRef.componentInstance.submitClicked.subscribe(result => {

        dialogSubmitSubscription.unsubscribe();
      });
  }
  ///------------------------  Add New Line in Chemotherapy   ------------------------------------------
  AddNewLine2(){
    if(this.patientCode == '' || this.patientCode == null){
      return;
    }
    const dialogRef = this.dialogref.open(PreprationLineComponent,
      {
        data: {
          dataKey: this.PreMedicationSelectedData,
          wk_autoserial : 0,
          wk_serial :this.documentCode,
          wk_category : '2',
          wk_protocol : this.prHdCode,
          wk_patientcode : this.patientCode,
          wk_itcode : '',
          wk_itname : '',
          wk_dose : '0',
          wk_unit :'16',
          wk_duration : '',
          wk_finaldose :'00.00',
          wk_dispensed :'00.00',
          wk_saved :'00.00',
          wk_important :'',
          wk_soloution :'',
          wk_rout : ''
        },
        width: '75vw',
      });
    dialogRef.afterClosed().subscribe(result => {
      this.prepListChemo =[];
      this.prepList =[];
      this.prepListSupp =[];
      this.retrivePreHD();
    });

      const dialogSubmitSubscription = dialogRef.componentInstance.submitClicked.subscribe(result => {
        dialogSubmitSubscription.unsubscribe();
      });
  }
  ///------------------------  Add New Line in Supportive TTT.   ------------------------------------------
  AddNewLine3(){
    if(this.patientCode == '' || this.patientCode == null){
      return;
    }
    const dialogRef = this.dialogref.open(PreprationLineComponent,
      {
        data: {
          dataKey: this.PreMedicationSelectedData,
          wk_autoserial : 0,
          wk_serial :this.documentCode,
          wk_category : '3',
          wk_protocol : this.prHdCode,
          wk_patientcode : this.patientCode,
          wk_itcode : '',
          wk_itname : '',
          wk_dose : '0',
          wk_unit :'16',
          wk_duration : '',
          wk_finaldose :'00.00',
          wk_prepFU : '',
          wk_dispensed :'00.00',
          wk_saved :'00.00',
          wk_important :'',
          wk_soloution :'',
          wk_rout : ''
        },
        width: '75vw',
      });
    dialogRef.afterClosed().subscribe(result => {
      this.prepListChemo =[];
      this.prepList =[];
      this.prepListSupp =[];
      this.retrivePreHD();
    });

      const dialogSubmitSubscription = dialogRef.componentInstance.submitClicked.subscribe(result => {
        dialogSubmitSubscription.unsubscribe();
      });
  }
  ///-------------------------------  Lookup Deug Items & Units  ------------------------------------------




////================================= Delete Prepartion Order ======================================
///-------------------***----------- Delete All Preapartion HD -------****-------------------
deletePrepHD(){
  this.preparationHDService.DelPrepHD(this.documentCode, this.storage.retrieve('stgcompCode')).subscribe(
    (data: PreparationHDModel) => {
      this.userID = data.userID;
      this.modifaiedDate = data.modifiedDate;

    }
  );
  this.deletePrepDet();
  this.NewData();
}
 ///-------------------***----------- Delete All Preapartion Details ---****------------------
  deletePrepDet() {
      this.preparationDetService.delPrepDetAll(this.documentCode,this.storage.retrieve('stgcompCode')).subscribe(
    (data: PreparationDetModel) => {

     // this.prDetCategory='1' ;
     // this.prDetCategory2='2' ;
     // this.prDetCategory3='' ;
     // this.compCode = data.compCode;
     // this.userID = data.userID;
     // this.modifaiedDate = data.modifiedDate;
    }
  );
}


  ///******************************** Doctors and Cancer ID Look ups ****************************************
  retriveDoctorsLookupTop() {
    this.doctorsService
      .getDoctorsLookupTopDep(this.compCode, 'Oncology')
      .subscribe((data: DoctorsModel[]) => {
        for (let i = 0; i < data.length; i++) {
          this.doctorsList[i] = data[i];
        }
        //console.log(data);
      });
  }
  retriveDoctorsLookupTopPh() {
    this.doctorsService
      .getDoctorsLookupTopDep(this.compCode, 'Pharmaceutical')
      .subscribe((data: DoctorsModel[]) => {
        for (let i = 0; i < data.length; i++) {
          this.doctorsLis1[i] = data[i];
        }

      });
  }
  retriveCancersLookupTop() {
    this.CanserService.getCancerLookupTop().subscribe((data:CanserModel[])=>{
  for(let i=0 ; i <data.length; i++)
  {this.cancerlist[i]=data[i];}
 })
  }


////=========================== Messages =========================================
  mesgSave() {
    Swal({
      title: 'Your work has been saved',
      type: 'success',
      showConfirmButton: false,

      timer: 1500,
    });
  }
  mesgDelete() {

    Swal({
      title: 'Are you sure?',
      text: 'You will not be able to recover this record!',
      type: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Yes, delete it!',
      cancelButtonText: 'No, keep it',
    }).then(() => {
        this.deletePrepHD();
        Swal('Deleted!', 'Your record has been deleted.', 'success');

      },
      function (dismiss) {
        if (dismiss === 'cancel') {
          Swal('Cancelled', 'Your record is safe :)', 'error');
        }
      }
    );
  }

  ////======================== Print PO ===============
  ReportPreparation(){
    this.Par1 = this.documentCode;
    this.storage.store('stgPar', this.documentCode);

    this.route.navigate(['report-vewier', this.ReportURL0]);
  }

  PreviousReportPreparation(sup : PreparationHDModel){
    this.Par1 = this.documentCode;
    this.storage.store('stgPar', sup.docNumber);


    ////******************************** */
        const dialogRef = this.dialogref.open(ReportdialogComponent,
          {
            data: {
              reportUrl: 'CocReports/PreparationOrder_D',

            },
            width: '40vw',
            height: '90vw',
          });
        dialogRef.afterClosed().subscribe(result => {
        });

        const dialogSubmitSubscription =
          dialogRef.componentInstance.submitClicked.subscribe(result => {
            dialogSubmitSubscription.unsubscribe();
          });
  }

  OpenCalc(){
    window.open('Calculator:///');
  }
}
